import * as React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";
import BadgeAchieventOverview from "src/components/badge-achievent-overview";
import request from "src/utils/request";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    margin: 0;
`;

const AchievementsAccordion = ({ isDemo, isTeams, isUnintegrated }) => {
    const [achievements, setAchievements] = React.useState([]);

    const getEndpointNextAchievements = async () => {
        let response;
        if (isDemo || isUnintegrated || isTeams) {
            response = (await import("./personal-achievements-mock-data")).default;
        } else {
            response = await request(`api/users/me/last-active-achievements`, { method: "GET" });
        }
        setAchievements(response);
    };
    React.useEffect(() => {
        if (isUnintegrated !== null) getEndpointNextAchievements();
    }, [isUnintegrated]);

    return (
        <div>
            <Stack direction="row" spacing={1} alignItems="center">
                <SectionTitle>Next Achievements</SectionTitle>
            </Stack>
            <Stack direction="column">
                {achievements.map((achievement) => (
                    <BadgeAchieventOverview
                        achievement={achievement}
                        key={achievement.achievementId}
                    />
                ))}
            </Stack>
        </div>
    );
};

export default AchievementsAccordion;
